import type { i18n as I18NType } from "i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
  NAMESPACES as BLOCKS_NAMESPACES,
  resolve as blocksResolve,
} from "../../translations/resolve";
import { LxI18NProps } from "../LxI18N.model";
import { lxI18NOptions } from "./lx-i18n-options";
import LxI18NBackend from "./LxI18NBackend";

let i18nInstance = i18n;

/**
 * Escape hatch to allow access to i18n from global scope (akin to the official `i18n` global instance)
 */
export function provideLxI18nInstanceInternal() {
  return i18nInstance;
}

// Function that initializes the i18n instance
export function initializeI18n(props: LxI18NProps) {
  const {
    locale = "de-DE",
    options = {},
    resolver,
    namespaces = [],
    testMode = false,
  } = props;
  const defaultOptions = lxI18NOptions(locale);
  const optionNamespaces = toArray(options.ns);

  const ns = testMode
    ? [...optionNamespaces, ...namespaces]
    : [...optionNamespaces, ...namespaces, ...BLOCKS_NAMESPACES];

  const resolvers = testMode ? [...resolver] : [...resolver, blocksResolve];

  const initOptions = {
    ...defaultOptions,
    ...options,
    interpolation: {
      ...defaultOptions.interpolation,
      ...options.interpolation,
    },
    ns,
    backend: { resolvers },
  };

  const nextI18N = i18n.createInstance();

  const ready = new Promise<I18NType>((resolve, reject) => {
    nextI18N
      .use(initReactI18next)
      .use(LxI18NBackend)
      .init(initOptions, (err) => {
        if (err) {
          reject(err);
        }
        i18nInstance = nextI18N;
        resolve(nextI18N);
      });
  });

  return { nextI18N, ready };
}

function toArray(ns?: string | readonly string[]): string[] {
  if (!ns) {
    return [];
  }
  return Array.isArray(ns) ? ns : [ns];
}
